import React from "react";
import Auth from "../../layouts/Auth";
import LoginForm from "../../components/login/LoginForm";

const Login = () => {
  return (
    <>
      <Auth>
        <LoginForm />
      </Auth>
    </>
  );
};
export default Login;
